<template>
  <section>
    <label :style="badgeStyle(value === referralProgramHistoryStatus.None)">
      <input
        type="radio"
        :checked="value === referralProgramHistoryStatus.None"
        @change="onFilterChange($event.target.value)"
        :value="referralProgramHistoryStatus.None"
        name="filter"
      />
      <span>All</span>
    </label>
    <label v-for="item in options" :key="item.id" :style="badgeStyle(value === item.id)">
      <input
        type="radio"
        :checked="value === item.id"
        @change="onFilterChange($event.target.value)"
        :value="item.id"
        name="filter"
      />
      <span>{{ item.text }} </span>
    </label>
  </section>
</template>

<script>
/* eslint-disable eqeqeq */
import { mapState } from 'vuex'
import { ReferralProgramHistoryStatus } from '@/shared/enums/referral.enum.js'
export default {
  name: 'referrals-filter',
  props: {
    value: {
      default: ReferralProgramHistoryStatus.None
    },
    options: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization
    })
  },
  methods: {
    onFilterChange (val) {
      this.$emit('change', val ? +val : null)
    },
    badgeStyle (selected) {
      return {
        color: this.customization.fontColor,
        'background-color': selected ? this.customization.mainColor : 'color-mix(in srgb, ' + this.customization.mainColor + ' 50%, white)'
      }
    }
  },
  data () {
    return {
      referralProgramHistoryStatus: ReferralProgramHistoryStatus
    }
  }
}
</script>

<style scoped>
section{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

input[type="radio"] {
  display: none;
}

label {
  position: relative;
  min-width: 48px;
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: #ccc;
  transition: all 0.2s ease-in-out;
  padding-inline: 12px;
  font-weight: normal;
  font-size: 14px;
} 
/* input[type="radio"]:checked ~ span {
  color: red;
} */
</style>



// WEBPACK FOOTER //
// referrals-filter.vue?542e1c81